import React from 'react'
import logo from '../logo.svg'

function Root () {
  const [data, setData] = React.useState(null)

  React.useEffect(() => {
    let isSubscribed = true
    window.fetch('/api')
      .then((res) => {
        if (res.status >= 400) {
          console.log(res)
          throw new Error('Server responds with error!')
        }
        return res.json()
      })
      .then((data) => {
        if (isSubscribed) {
          setData(data.message)
        }
      }).catch((ex) => {
        console.log('parsing failed', ex)
      })
    return () => { isSubscribed = false }
  }, [])

  return (
    <div className='App'>
      <header className='App-header'>
        <img src={logo} className='App-logo' alt='logo' />
        <p>{!data ? 'Loading...' : data}</p>
      </header>
    </div>
  )
}

Root.propTypes = { }

export default Root
